<!-- Shared menu item template -->
<ng-template #menuItemTemplate let-item>
  <div
    class="menu-item-wrapper d-flex align-items-center pointerCursor"
    [ngClass]="{
      'flex-column': isMobile(),
      'flex-row psic-p-3 psic-gap-3 psic-br-2': !isMobile(),
      'p3-5-background': !isMobile() && getMenuItemState(item.label) === 'selected',
    }"
    (click)="selectMenuItem(item.label)"
    (mouseenter)="onMenuItemHover(item.label)"
    (mouseleave)="onMenuItemLeave()"
  >
    <mat-icon
      [svgIcon]="item.icon"
      [ngClass]="getMenuItemState(item.label) === 'selected' ? 'p3-80-color' : 'dg-60-color'"
    ></mat-icon>
    <span
      [ngClass]="{
        microtext: isMobile(),
        'item-text caption': !isMobile(),
        'p3-80-color': getMenuItemState(item.label) === 'selected',
        'dg-60-color': getMenuItemState(item.label) !== 'selected',
      }"
      >{{ item.label }}</span
    >
  </div>
</ng-template>

@if (isMobile()) {
<!-- Mobile Mode -->
<div
  class="bottom-menu d-flex flex-row align-items-center psic-px-3 wh-100-background"
>
  @for (item of menuItems(); track item.label) { @if (!item.disabled) {
  <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: item }"></ng-container>
  } }
</div>
} @else {
<!-- Desktop/Tablet Mode -->
<div class="side-menu d-flex flex-column psic-gap-6 psic-p-8 wh-100-background">
  <!-- menu header -->
  <h3>{{ menuHeader() }}</h3>

  <div class="d-flex flex-column psic-gap-1">
    @if(displayPolicyNumber()){
    <div class="caption-bold">{{ displayPolicyNumber() }}</div>
    } @if(propertyAddress()){
    <div class="caption">{{ propertyAddress() }}</div>
    }
  </div>

  <!-- menu body -->
  <div class="d-flex flex-column psic-gap-8">
    <!-- menu items -->
    <div>
      @for (item of menuItems(); track item.label) { @if (!item.disabled) {
      <ng-container
        *ngTemplateOutlet="menuItemTemplate; context: { $implicit: item }"
      ></ng-container>
      } }
    </div>

    <!-- Payment button -->
    @if (isBilling()) {
    <lib-button
      [buttonText]="'Make a Payment'"
      [buttonSize]="'large'"
      [buttonTheme]="'secondary'"
      [disabled]="showMakePayment() ? false : true"
      (click)="navigateToMakePayment()"
    ></lib-button>
    }
  </div>
</div>
}
